import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button, Divider, Col, Row } from '_zari/core'

import * as SedeCrud from 'services/sede.service'

import { ValidationSchema } from './validation'
import * as FormGroups from './formGroups'

const NuevoModal = ({ handleClose, show, reloadTable, editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      _idListaPrecio: editarData._idListaPrecio || '',
      anexo: editarData.anexo || '',
      direccion: editarData.direccion || '',
      flagVentasSinStock: editarData.flagVentasSinStock || false,
      flagECommerce: editarData.flagECommerce || false,
      nombre: editarData.nombre || '',
      telefono: editarData.telefono || '',
      ubigeo: editarData.ubigeo || ''
    }),
    [editarData]
  )

  const submitHandler = React.useCallback(
    async data => {
      if (editarData._id) {
        await SedeCrud.actualizarSede(editarData._id, data)
          .then(() => {
            __zariContext.snack('success', 'El registro se ha actualizado.')
            reloadTable()
            handleClose()
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      } else {
        await SedeCrud.nuevaSede(data)
          .then(() => {
            __zariContext.snack('success', 'El registro se ha agregado.')
            reloadTable()
            handleClose()
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      }
    },
    [__zariContext, reloadTable, handleClose, editarData._id]
  )

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title> {editarData._id ? 'ACTUALIZAR SEDE' : 'NUEVA SEDE'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col xs={6}>
                  <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
                </Col>
                <Col xs={6}>
                  <FormGroups.TelefonoFormGroup iError={errors.telefono} iTouched={touched.telefono} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <FormGroups.DireccionFormGroup iError={errors.direccion} iTouched={touched.direccion} fIsSubmitting={isSubmitting} />
              <Row>
                <Col xs={6}>
                  <FormGroups.AnexoFormGroup iError={errors.anexo} iTouched={touched.anexo} fIsSubmitting={isSubmitting} />
                </Col>
                <Col xs={6}>
                  <FormGroups.UbigeoFormGroup iError={errors.ubigeo} iTouched={touched.ubigeo} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              {/* <Divider title='VALORES CONFIGURACION' />
              <Row>
                <Col xs={6} sm={4}>
                  <FormGroups.FlagVentasSinStockFormGroup iValue={values.flagVentasSinStock} fIsSubmitting={isSubmitting} />
                </Col>
                <Col xs={6} sm={4}>
                  <FormGroups.FlagECommerceFormGroup iValue={values.flagECommerce} fIsSubmitting={isSubmitting} />
                </Col>
              </Row> */}
              <Divider title='OTROS' />
              <Row>
                <Col xs={6}>
                  <FormGroups.IdListaPrecioFormGroup iError={errors._idListaPrecio} iTouched={touched._idListaPrecio} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoModal
